import { render, staticRenderFns } from "./ReasonDropdown.vue?vue&type=template&id=4a0c3fe8&scoped=true"
import script from "./ReasonDropdown.vue?vue&type=script&lang=ts"
export * from "./ReasonDropdown.vue?vue&type=script&lang=ts"
import style0 from "./ReasonDropdown.vue?vue&type=style&index=0&id=4a0c3fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c3fe8",
  null
  
)

export default component.exports